import { IPaged } from '../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  private readonly PAGE_SIZE = 5;

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id',
    sortDir: 'Descending'
  };


  constructor() { }

  ngOnInit(): void {
  }
}